import { render, staticRenderFns } from "./TeacherSloganConfig.vue?vue&type=template&id=01df1a91&scoped=true&"
import script from "./TeacherSloganConfig.vue?vue&type=script&lang=js&"
export * from "./TeacherSloganConfig.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSloganConfig.vue?vue&type=style&index=0&id=01df1a91&scoped=true&lang=css&"
import style1 from "./TeacherSloganConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df1a91",
  null
  
)

export default component.exports